import { useState } from 'react'
import { useMediaQuery } from '@mantine/hooks'
import Image from 'next/image'
import styles from './kdt-bebj-17th.module.scss'

interface IProgramTabProps {
  programDescList: {
    category: string
    imgUrlPc: string
    imgUrlM: string
    descList: string[]
  }[]
}

const ProgramTab = ({ programDescList }: IProgramTabProps) => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const [value, setValue] = useState(programDescList[0]?.category || '')
  const onClickTab = (step: string) => {
    setValue(step)
  }
  const selectedDetail = programDescList.find(detail => detail.category === value)
  const [openAccordions, setOpenAccordions] = useState<Record<string, boolean>>({})
  const toggleOpen = (id: string) => {
    setOpenAccordions(prev => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  return (
    <>
      <ul className="flex flex-row gap-3">
        {programDescList.map(detail => (
          <li
            key={detail.category}
            className="flex flex-1 flex-row items-center gap-8"
            onClick={() => onClickTab(detail.category)}
          >
            <div
              className={`${
                value === detail.category
                  ? 'border-[#FDFDFD] bg-[#FDFDFD]'
                  : 'border-[#525252] bg-[#2E2E2E]'
              } flex-1 cursor-pointer rounded-t-lg border border-b-0 px-0 py-3 lg:px-8 lg:py-6`}
            >
              <h6
                className={`${
                  value === detail.category ? 'text-yellow-450' : 'text-label-alternative'
                } whitespace-pre-line text-center text-base font-bold leading-normal lg:whitespace-normal lg:text-left lg:text-2xl`}
              >
                {detail.category}
              </h6>
            </div>
          </li>
        ))}
      </ul>

      <div className="w-full rounded-b-lg border border-[#FDFDFD] bg-[#FDFDFD] p-4 lg:p-8">
        {selectedDetail && (
          <div className="flex w-full flex-col items-center gap-3 lg:flex-row lg:gap-11">
            <div className="w-full overflow-hidden rounded lg:w-[340px]">
              <Image
                src={isMobile ? selectedDetail.imgUrlM : selectedDetail.imgUrlPc}
                layout="fill"
                objectFit="cover"
                className="!relative"
                alt="-"
              />
            </div>
            <div className="flex w-full flex-col lg:w-auto lg:flex-1">
              <ul className="flex flex-col">
                {selectedDetail.descList.map(desc => (
                  <li
                    key={desc}
                    className="border-t py-2 first-of-type:border-t-0 first-of-type:pt-0 last-of-type:pb-0"
                  >
                    <p
                      className={`${styles.text_dot} ${styles.text_dot_program} text-sm leading-normal text-label-normal lg:text-lg`}
                    >
                      {desc}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default ProgramTab
